import { IconButton } from "@suraasa/placebo-ui"
import { theme, useMediaQuery } from "@suraasa/placebo-ui-legacy"
import clsx from "clsx"
import { useGlobalContext } from "global/Context/context"
import { Download } from "iconoir-react"
import { downloadFile, formatDate } from "utils/helpers"

import styles from "./cpatCard.module.css"

const svgProps = { width: 20, height: 20 }

const CpatCard = ({ file, issuedAt }: { file: string; issuedAt: string }) => {
  const isXsDown = useMediaQuery(theme.breakpoints.down("xs"))
  const { isNcte } = useGlobalContext()
  const handleDownload = (e: { stopPropagation: () => void }) => {
    e.stopPropagation()
    downloadFile(file, `CPAT Report.pdf`)
  }

  return (
    <button
      onClick={handleDownload}
      className={clsx(
        "relative flex h-[240px] w-full flex-col justify-between rounded-lg border-[5px] border-surface-500 p-2 shadow-[0_8px_25px_0_rgba(0,0,0,0.15)] sm:h-[278px] sm:px-3 sm:py-4  md:h-[292px]",
        styles.container
      )}
    >
      <div className="z-10">
        <span
          className={clsx("mb-0.5  block text-onSurface-600", styles.dateText)}
        >
          {formatDate(issuedAt, "do MMMM yyyy")}
        </span>
        <span className={clsx(styles.title, "text-onSurface-900")}>
          {isNcte
            ? "National Council for Teacher Education Assessment"
            : "Comprehensive Pedagogy Assessment of Teachers"}
        </span>
      </div>
      {!isXsDown && (
        <div className="z-10 flex">
          <IconButton onClick={handleDownload} color="black" className="me-2">
            <Download {...svgProps} />
          </IconButton>
        </div>
      )}
    </button>
  )
}

export default CpatCard
